export default [
    {
        path: '/specializations',
        name: 'specializations',
        component: () => import('@/views/specialization/SpecializationsView.vue'),
        meta: {
            requiresAuth: true
        }
    }
]
